import {TFunction} from '@/i18n'
import {getPluralSuffixForCount} from '@/utils/translations/helpers'

export const useFormSummaryContent = () => ({
  summaryTitle: 'forms.cart-title',
  trademarkTitle: 'trademark-text',
  logoTrademarkTitle: 'logo-tm-placeholder',
  figurativeTrademarkTitle: 'figurative-tm-placeholder',
  wordTrademarkTitle: 'word-tm-placeholder',
  combinedTrademarkTitle: 'combined-tm-placeholder',
  showText: 'show-text',
  hideText: 'hide-text',
  countryTitle: 'country-text',
  countriesTitle: 'countries-text',
  serviceFeeTitle: 'pricing-reg-table-header-1',
  administrativeFeeTitle: 'pricing-reg-table-header-2',
  goodsAndServicesTitle: 'forms.goods-and-services-title',
  classTitle: 'class-title',
  classesTitle: 'pricing-reg-table-header-7',
  includedClassesTitle: 'pricing-reg-table-header-4',
  secondClassTitle: 'pricing-reg-table-header-10',
  secondAndThirdClassTitle: 'pricing-second-and-third-class-title',
  eachAdditionalClassTitle: 'pricing-reg-table-header-11',
  extraClassTitle: 'pricing-reg-table-header-5',
  totalPriceTitle: 'pricing-reg-table-header-3',
  multiCountryDiscountTitle: 'multi-country-discount-title',
  serviceFeeDiscountTitle: 'pricing-reg-table-header-9',
  discountCouponTitle: 'forms.discount-coupon',
  estimatedPriceTitle: 'pricing-estimated-price-title',
  estimatedPriceNote: 'verification-cart-price-note',
  priceExclVatTitle: 'forms.price-excl-vat',
  priceInclVatTitle: 'forms.price-incl-vat',
  vatTitle: 'forms.price-vat',
  vatTooltip: 'forms.vat-tooltip',
  applyDiscountCouponTitle: 'forms.apply-discount-coupon-title',
  applyDiscountCouponLabel: 'forms.apply-discount-coupon-label',
  applyDiscountCouponButton: 'forms.apply-discount-coupon-button',
  appliedDiscountDescription: 'discount-applied',
  removedDiscountDescription: 'discount-removed',
  verificationResultTitle: 'ver-sum-header-label',
  resultTmApproved: 'ver-sum-result-tm-approved',
  emptySummaryTitle: 'forms.empty-summary-title',
  emptySummaryDescription: 'forms.empty-summary-desc',
  freeTitle: 'ver-price-free',
  endToEndProtectionTitle: 'end-to-end-protection-title',
  endToEndGuaranteeTitle: 'end-to-end-guarantee-title',
  endToEndGuaranteeTooltip: 'end-to-end-guarantee-tooltip',
  serviceNameTitle: 'pricing-service-table-header-0',
  serviceDetailsTitle: 'service-details-title',
  registrationNumberTitle: 'registration-number-title',
  tmNumberTitle: 'trademark-number-title',
  domainNameTitle: 'domain-title',
  numberOfClassesLabel: 'number-of-classes-label',
  feesTitle: 'forms.price-fees-title',
  quantityTitle: 'inv-table-pc',
  classCountTitle: 'class-count',
  additionalServiceTitle: 'forms.additional-service-title',
  brandMonitoringTitle: 'legal-services-brand-monitoring-title',
})

export const getFormSummaryExtraClassesTitle = (numOfExtraClasses: number, t: TFunction) => {
  const suffix = getPluralSuffixForCount(numOfExtraClasses)

  return t(`extra-class-count-${suffix}`, {count: numOfExtraClasses})
}
